import * as types from './mutationTypes'

const mutations = {
  [types.SET_USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_SHOP_CAR] (state, shopCar) {
    state.shopCar = shopCar
  },
  [types.IS_SEND_CODE] (state, isSendCode) {
    state.isSendCode = isSendCode
  },
  [types.SEARCH_TEXT] (state, searchText) {
    state.searchText = searchText
  },
  [types.SHOP_CAR_COUNT] (state, count) {
    state.shoCartCount = count
  },
  [types.SHOW_LOGIN] (state, login) {
    state.login = login
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js